import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components';

export const ForPartnersPage: React.FC = () => {
  const { t } = useTranslation('pages');
  const resultItems = t('forPartners.resultItems', { returnObjects: true }) as string[];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-[#0B1F3A]">{t('forPartners.title')}</h1>
        <p className="mt-4 text-xl text-gray-700 font-semibold">
          {t('forPartners.subtitle')}
        </p>
      </div>

      <div className="space-y-8 text-gray-700">
        <p className="text-lg">{t('forPartners.intro')}</p>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-4">{t('forPartners.benefitsTitle')}</h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-xl font-semibold text-[#0B1F3A] mb-2">{t('forPartners.screeningTitle')}</h3>
              <p>{t('forPartners.screeningText')}</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-[#0B1F3A] mb-2">{t('forPartners.pricingTitle')}</h3>
              <p>{t('forPartners.pricingText')}</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-[#0B1F3A] mb-2">{t('forPartners.cockpitTitle')}</h3>
              <p>{t('forPartners.cockpitText')}</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>{t('forPartners.cockpitItem1')}</li>
                <li>{t('forPartners.cockpitItem2')}</li>
                <li>{t('forPartners.cockpitItem3')}</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-[#0B1F3A] mb-2">{t('forPartners.contractTitle')}</h3>
              <p>{t('forPartners.contractText')}</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-[#0B1F3A] mb-2">{t('forPartners.accountManagerTitle')}</h3>
              <p>{t('forPartners.accountManagerText')}</p>
            </div>
          </div>
        </section>

        <section className="bg-blue-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forPartners.resultTitle')}</h2>
          <ul className="list-disc pl-6 space-y-2">
            {Array.isArray(resultItems) && resultItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p className="mt-4 font-semibold">{t('forPartners.resultEmphasis')}</p>
        </section>

        <section className="text-center py-8">
          <p className="text-lg font-semibold text-gray-800 mb-4">{t('forPartners.readyQuestion')}</p>
          <p className="text-lg text-gray-700 mb-6">{t('forPartners.joinCta')}</p>
          <Link to="/register">
            <Button size="lg" variant="primary">
              {t('forPartners.registerButton')}
            </Button>
          </Link>
        </section>
      </div>
    </div>
  );
};
